import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '@environments/environment';
import { DecoIconComponent } from '@shared/components/deco-icon/deco-icon.component';
import { HeaderMixpanelService } from '@shared/mixpanel';

@Component({
    selector: 'app-menu-support[closePopover]',
    templateUrl: './menu-support.component.html',
    styleUrls: ['./menu-support.component.scss'],
    imports: [TranslateModule, DecoIconComponent, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuSupportComponent {
    closePopover = output<void>();

    readonly supportHubUrl = environment.supportHubUrl;
    readonly termsOfUseUrl = environment.tyxTermsOfService;

    constructor(private mixpanel: HeaderMixpanelService) {}

    close(): void {
        this.closePopover.emit();
    }

    openChat(): void {
        // @ts-ignore
        window['happyFoxChat'].showWidget();
        // @ts-ignore
        window['happyFoxChat'].expandChatbox();
        this.close();
    }

    goToSupportHub(): void {
        window.open(this.supportHubUrl, '_blank');
    }

    callPhone(): void {
        window.open(`tel:1-888-321-2113`, '_blank');
    }

    openEmail(): void {
        window.open(`mailto:help@transnetyx.com`, '_blank');
    }

    goToTermsOfUse(): void {
        window.open(this.termsOfUseUrl, '_blank');
    }

    logAction(action: 'support-hub' | 'mail' | 'phone' | 'terms-of-use' | 'chat') {
        switch (action) {
            case 'support-hub':
                this.mixpanel.logSupportHubRedirect();
                break;
            case 'chat':
                this.mixpanel.logOpenChat();
                break;
            case 'mail':
                this.mixpanel.logMailRedirect();
                break;
            case 'phone':
                this.mixpanel.logOpenPhoneModal();
                break;
            case 'terms-of-use':
                this.mixpanel.logOpenTermsOfUse();
                break;
        }
    }
}
